import './TextCtaPreviewBlock.scss'

import {ImageType, InternalLinkType, WysiwygType} from '../../types'

import {Block} from './Blocks'
import {CtaPreview} from '../layout/cta/CtaPreview'
import {Image} from '@codeurs/front'
import React from 'react'
import {Theme} from '../Theme'
import {style} from '../../util/style'

const styles = style('textctapreviewblock')

export type TextCtaPreviewType = {
	cta_page: InternalLinkType
	cta_title: string
	cta_text: WysiwygType
	cta_btnlabel: string
	cta_image: ImageType
}

export type TextCtaPreviewBlockType = {
	text: WysiwygType
} & TextCtaPreviewType

export const TextCtaPreviewBlock: React.FC<
	TextCtaPreviewBlockType & {container?: boolean; sidebar?: boolean}
> = ({
	cta_page,
	cta_title,
	cta_text,
	cta_btnlabel,
	cta_image,
	container,
	text
}) => {
	if (!text && !cta_text && !cta_btnlabel) return null

	return (
		<Block className={styles()} container={container}>
			<div className={styles('content')}>
				<div className={styles('content-text')}>
					{text && <Theme.Wysiwyg>{text}</Theme.Wysiwyg>}
				</div>
				<div className={styles('content-cta')}>
					<CtaPreview
						url={cta_page?.url}
						title={cta_title || cta_page?.title}
						image={cta_image}
						text={cta_text}
						btnlabel={cta_btnlabel}
						price={null}
						preview_image={null}
						preview_title={null}
						preview_text={null}
						hero_image={null}
						hero_title={null}
						hero_text={null}
					/>
				</div>
			</div>
		</Block>
	)
}
